import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOarsLogoBlack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 86.38,
	height: 25.185,
	viewBox: "0 0 86.38 25.185",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_17",
		"data-name": "Group 17",
		transform: "translate(-26 -21.755)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_3",
			"data-name": "Group 3",
			transform: "translate(-189 -194.745)",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Group_1",
				"data-name": "Group 1",
				transform: "translate(85 -11.332)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "noun-progressing-4621977_1_",
					"data-name": "noun-progressing-4621977 (1)",
					transform: "translate(119.635 220.438)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Path_3",
							"data-name": "Path 3",
							d: "M26.065,7.83a11.486,11.486,0,0,1,3,1.248,12.761,12.761,0,0,1,4.588,4.588,12.529,12.529,0,0,1,1.685,6.242,11.45,11.45,0,0,1-.094,1.436c-.031.125-.031.281-.062.406a11.19,11.19,0,0,1-.281,1.4,2.02,2.02,0,0,1-.125.406,12.746,12.746,0,0,1-1.124,2.59,13.341,13.341,0,0,1-2,2.59A14.222,14.222,0,0,1,30.4,29.834a12.275,12.275,0,0,1-4.338,2.154,12.474,12.474,0,0,1-2.84.406H22.85A12.564,12.564,0,0,1,21.32,32.3c-.062,0-.125-.031-.187-.031a11.585,11.585,0,0,1-1.5-.312,11.486,11.486,0,0,1-3-1.248,13.341,13.341,0,0,1-2.59-2,12.382,12.382,0,0,1-2.029-2.59,12.663,12.663,0,0,1-1.248-3,12.846,12.846,0,0,1-.406-3.246,9.475,9.475,0,0,1,.125-1.623,11.985,11.985,0,0,1,.312-1.592v-.031l3.933,1.061a8.413,8.413,0,0,0,3.4,9.207A8.25,8.25,0,0,0,23.1,28.336a8.61,8.61,0,0,0,4.869-1.717A8.279,8.279,0,0,0,30.9,22.375a8.409,8.409,0,0,0-3.121-9.3A8.4,8.4,0,0,0,22.85,11.45V7.393a12.059,12.059,0,0,1,1.5.094c.094,0,.187.031.281.031a10.66,10.66,0,0,1,1.436.312Z",
							transform: "translate(0 0)",
							fill: "#071337"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_4",
							"data-name": "Path 4",
							d: "M308.695,31.445a7.743,7.743,0,0,1,2.029-.843l-1.061-3.932a12.662,12.662,0,0,0-3,1.248Z",
							transform: "translate(-290.058 -18.871)",
							fill: "#037c96"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Path_5",
							"data-name": "Path 5",
							d: "M93.756,183.619a8.138,8.138,0,0,0-1.342,1.748l-3.527-2.029a13.341,13.341,0,0,1,2-2.59Z",
							transform: "translate(-76.867 -169.703)",
							fill: "#037c96"
						})
					]
				})
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_8",
				"data-name": "Path 8",
				d: "M5.612-.436H.831l8.712-24.3h5.525l8.712,24.3H19L12.4-19.75h-.193Zm.155-9.529h13.04v3.54H5.767ZM25.107-.436v-24.3H34.39a10.591,10.591,0,0,1,4.781.974,6.762,6.762,0,0,1,2.936,2.725A8.106,8.106,0,0,1,43.1-16.96,7.841,7.841,0,0,1,42.1-12.914a6.638,6.638,0,0,1-2.963,2.645,11.141,11.141,0,0,1-4.81.931H27.716v-3.645h6.008a6.944,6.944,0,0,0,2.725-.458,3.211,3.211,0,0,0,1.574-1.344,4.293,4.293,0,0,0,.511-2.175,4.46,4.46,0,0,0-.514-2.211,3.32,3.32,0,0,0-1.582-1.4,6.664,6.664,0,0,0-2.743-.485h-4.1V-.436Zm12.779-11.01L44.01-.436h-5L33-11.445Zm20.848-6.606a3.229,3.229,0,0,0-1.417-2.42,5.594,5.594,0,0,0-3.248-.864,6.3,6.3,0,0,0-2.4.411A3.539,3.539,0,0,0,50.137-19.8a2.666,2.666,0,0,0-.54,1.625,2.308,2.308,0,0,0,.351,1.316,3.115,3.115,0,0,0,.974.942,6.819,6.819,0,0,0,1.362.65,14.159,14.159,0,0,0,1.514.443l2.318.569a16.5,16.5,0,0,1,2.7.864,9.547,9.547,0,0,1,2.325,1.373,6.175,6.175,0,0,1,1.631,2A5.99,5.99,0,0,1,63.38-7.26,6.51,6.51,0,0,1,62.266-3.5a7.27,7.27,0,0,1-3.2,2.527A12.68,12.68,0,0,1,54-.065a13,13,0,0,1-5-.88,7.429,7.429,0,0,1-3.313-2.565,7.424,7.424,0,0,1-1.283-4.1h4.4A3.644,3.644,0,0,0,49.6-5.5,4.216,4.216,0,0,0,51.433-4.24a7.292,7.292,0,0,0,2.529.416,6.99,6.99,0,0,0,2.567-.435,4.089,4.089,0,0,0,1.736-1.215A2.829,2.829,0,0,0,58.9-7.288a2.3,2.3,0,0,0-.56-1.573,4.242,4.242,0,0,0-1.553-1.044,16.025,16.025,0,0,0-2.33-.752l-2.811-.721a11.346,11.346,0,0,1-4.822-2.34A5.3,5.3,0,0,1,45.057-17.9a6.141,6.141,0,0,1,1.182-3.76,7.808,7.808,0,0,1,3.241-2.508,11.488,11.488,0,0,1,4.647-.9,11.164,11.164,0,0,1,4.622.9,7.538,7.538,0,0,1,3.121,2.478,6.325,6.325,0,0,1,1.172,3.64Z",
				transform: "translate(238 241.75)",
				fill: "#071337"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Icon_map-health",
			"data-name": "Icon map-health",
			d: "M9.34,3.593a.18.18,0,0,0-.18-.18H6.826a.18.18,0,0,1-.18-.18V.9a.18.18,0,0,0-.18-.18H3.593a.18.18,0,0,0-.18.18V3.234a.18.18,0,0,1-.18.18H.9a.18.18,0,0,0-.18.18V6.467a.18.18,0,0,0,.18.18H3.234a.18.18,0,0,1,.18.18V9.16a.18.18,0,0,0,.18.18H6.467a.18.18,0,0,0,.18-.18V6.826a.18.18,0,0,1,.18-.18H9.16a.18.18,0,0,0,.18-.18Z",
			transform: "translate(33.28 29.318)",
			fill: "#037c96"
		})]
	})]
});
const ForwardRef = forwardRef(SvgOarsLogoBlack);
export default ForwardRef;
